export const colors = {
    OFF: '#77787b',
    ON: '#8bb762',
    SAFE: '#0080c5',
    STANDBY: '#91c5ea',
    HOLD: '#fcb813',
    FAULT: '#e83e2e',
    OLD: '#231f20'
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/constants/color.constant.js